export default "__VITE_ASSET__3b17d793__"